// extracted by mini-css-extract-plugin
export var background = "bn_y";
export var backgroundContainer = "bn_fC";
export var bottomImage = "bn_t";
export var bottomImageContainer = "bn_fK";
export var buttons = "bn_cr";
export var container = "bn_b";
export var imagesContainer = "bn_fJ";
export var middleWave = "bn_cT";
export var section = "bn_d";
export var text = "bn_b0";
export var textContainer = "bn_cW";
export var title = "bn_h";
export var topImage = "bn_m";
export var waveOverlay = "bn_fH";